var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/whatsappIconDisabled.20a3aa79.png","uri@2x": __webpack_public_path__ + "static/media/whatsappIconDisabled.ac6b9ad9.png","uri@3x": __webpack_public_path__ + "static/media/whatsappIconDisabled.7b2fee75.png",
    width: 16,
    height: 16
});